export default "__VITE_ASSET__Dv5Ft2dn__"